import React from 'react';
import { Link } from 'react-router-dom';
import { PWA_CREATE_SOT_VALUES, pwaCreateSotHref } from './createPwaJob';
import { pwaJobsSotExitHref } from './ordersSurface';

const CREATE_SOT_LABELS: Record<string, string> = {
    error: 'CREATE · ERROR',
    offline: 'CREATE · OFFLINE',
    denied: 'CREATE · DENIED',
};

type Props = {
    active?: string | null;
};

const CreateSotSwitcher = ({ active = null }: Props) => (
    <nav className="jobs-sot-switcher" data-testid="create-sot-switcher" aria-label="PWA create SoT">
        {PWA_CREATE_SOT_VALUES.map((surface) => (
            <Link
                key={surface}
                className={`jobs-sot-link${active === surface ? ' is-active' : ''}`}
                to={pwaCreateSotHref(surface)}
            >
                {CREATE_SOT_LABELS[surface]}
            </Link>
        ))}
        <Link className="jobs-sot-link" to={pwaJobsSotExitHref()}>
            Exit SoT
        </Link>
    </nav>
);

export default CreateSotSwitcher;
